"use client"

import { Typography } from "@mui/material"
import { motion } from "framer-motion"

const GradientText = ({ children, variant = "h2", component, sx = {} }) => {
  return (
    <Typography
      component={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      variant={variant}
      sx={{
        background: (theme) => theme.palette.gradient.main,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
        fontWeight: 700,
        ...sx,
      }}
    >
      {children}
    </Typography>
  )
}

export default GradientText

